import { render, staticRenderFns } from "./OpeningJournal.vue?vue&type=template&id=054b11bc"
import script from "./OpeningJournal.vue?vue&type=script&lang=js"
export * from "./OpeningJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports